<template>
  <div style="cursor: move" v-if="ansiWindow">
    <b-row
      :class="
        'col-lg-12 remove-window-spacing ' +
        (showModal ? 'window-width' : 'window-widthfixed')
      "
    >
      <b-col :class="showModal ? 'col-lg-4' : 'col-lg-0'" style="padding-right: 0px !important">
        <div class="notes_panel" v-show="showModal">
          <h6 class="notes-panel-title">
            <fa :icon="['fas', 'sticky-note']" class="mr-1" />
            <strong>Notes Template</strong>
          </h6>
          <div class="scroll-Container">
            <b-row v-for="element in ansi_notes" :key="element.id">
              <b-col class="my-1 mx-1">
                <b-button
                  title="Click to paste in Notes."
                  :key="element.note"
                  :id="element.id"
                  @click="pushToNotes(element.note)"
                  size="sm"
                  class="btn ansi-button text-left"
                  variant="btn-primary"
                >
                  * {{ element.note }}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <b-col :class="showModal ? 'col-lg-8' : 'col-lg-12'" style="padding: 0">
        <div>
          <!-- // Refactored updateSite => updateSite() -->
          <b-card class="panel" header-class="ansi-testing-header">
            <template #header>
              <div style="display: flex; align-items: center; gap: 6px;">
                <div style="flex: 1">
                  <b-button
                    id="submitAnsiBtn"
                    size="sm"
                    class="btn greenBtn"
                    variant="btn-primary"
                    block
                    @click="updateSite()"
                  >
                    Update
                  </b-button>
                </div>
                <div style="flex: 1">
                  <b-button
                    size="sm"
                    class="btn ansi-button"
                    variant="btn-primary"
                    id="togglePass"
                    block
                    @click="togglePass()"
                  >
                    Toggle Pass
                  </b-button>
                </div>
                <div style="flex: none; display: flex; align-items: center; padding-left: 4px;">
                  <button
                    type="button"
                    class="close-icon-btn"
                    title="Close"
                    aria-label="Close"
                    @click="closeWindow()"
                  >
                    <fa :icon="['fas', 'times']" />
                  </button>
                </div>
              </div>
            </template>
            <b-row v-if="layerDefinition == 'ANSI'" class="info-grid mt-2">
              <b-row class="col-md-12 py-1 mx-3">
                <!-- <b-col class="col-md-6">
                  <label><b>DMP ANSI ID: </b>{{ this.ushrId }}</label>
                </b-col> -->
                <b-col class="col-md-6">
                  <label><b>SEGMENT ID: </b>{{ this.segmentId }}</label>
                </b-col>
              </b-row>
              <b-row class="col-md-12 py-1 mx-3">
                <b-col class="col-md-6">
                  <label><b>TECHNICIAN: </b>{{ this.technician }}</label>
                </b-col>
                <b-col class="col-md-6" v-if="apiUrl == 'ansi_gm'">
                  <label><b>PART NUMBER: </b>{{ this.part_number }}</label>
                </b-col>
              </b-row>
              <b-row class="col-md-12 py-1 mx-3">
                <b-col class="col-md-6">
                  <label><b>STATE: </b>{{ this.state_name }}</label>
                </b-col>
                <b-col class="col-md-6">
                  <label><b>ROAD TYPE: </b>{{ this.road_type }}</label>
                </b-col>
              </b-row>
            </b-row>
            <b-row v-if="layerDefinition == 'HD'" class="info-grid mt-2">
              <b-row class="col-md-12 py-1 mx-3">
                <b-col class="col-md-6">
                  <label><b>OSM ID: </b>{{ this.osm_id }}</label>
                </b-col>
                <b-col class="col-md-6">
                  <label><b>SEGMENT ID: </b>{{ this.segmentId }}</label>
                </b-col>
              </b-row>
              <b-row class="col-md-12 py-1 mx-3">
                <b-col class="col-md-6">
                  <label><b>TECHNICIAN: </b>{{ this.technician }}</label>
                </b-col>
                <b-col class="col-md-6" v-if="apiUrl == 'ansi_gm'">
                  <label><b>PART NUMBER: </b>{{ this.part_number }}</label>
                </b-col>
              </b-row>
            </b-row>
            <b-row class="mx-2">
              <b-col>
                <b-row class="notesRow">
                  <label class="notes">Notes</label>
                  <fa
                    size="lg"
                    title="Open Notes Template"
                    class="greenBtn testingWindowNotes"
                    :icon="['fas', 'angle-down']"
                    @click="showNotesModal()"
                  />
                  <MMP_NotesTemplate 
                    class="cog-position"
                    @updateNotes="getAnsiNotes()"
                  ></MMP_NotesTemplate>
                </b-row>
                <b-form-textarea
                  id="notes"
                  @mouseup="enableInput($event)"
                  @mousedown="enableInput($event)"
                  rows="4"
                  cols="50"
                  style="resize: none"
                  class="contenteditable-element"
                  v-model="notes"
                  ref="notes"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="boxed section-bar py-1 px-4 mt-2" align-v="center">
              <b-col v-if="layerDefinition == 'HD'">
                <label class="section-title my-1">REQUIRED</label>
              </b-col>
              <b-col v-if="layerDefinition != 'HD'">
                <label class="section-title my-1">ATTRIBUTES</label>
              </b-col>
              <!-- WEBGIS-2879 - remove Toggle Pass Btn since all props are "required" -->
              <!-- <b-col class="text-center" v-if="layerDefinition == 'ANSI'">
                <b-button
                  size="sm"
                  class="ansi-button"
                  variant="btn-primary"
                  id="togglePass"
                  @click="toggleCategoryPass('required')"
                >
                  Toggle Pass
                </b-button>
              </b-col> -->
            </b-row>
            <div class="scroll-Container">
              <b-row
                align-h="between"
                class="prop-row py-1 px-4 mt-2"
                v-for="prop in ansiProperties.filter(e => e.type === 'required')"
                :key="prop.id"
              >
                <b-col cols="8" class="p-2">
                  <span class="prop-name">
                    <strong>{{ prop.prop }}</strong>
                  </span>
                </b-col>
                <b-col cols="4">
                  <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label
                      :class="
                        prop.value == 'not_validated'
                          ? 'btn dashed-border grayBtn'
                          : 'btn dashed-border unSelectedIcons'
                      "
                    >
                      <input
                        type="radio"
                        :checked="prop.value == 'not_validated'"
                        :name="prop.prop"
                        id="option1"
                        autocomplete="off"
                        value="not_validated"
                        title="Not Validated"
                        @change="changed($event, prop.prop)"
                      />
                      <span
                        class="glyphicon glyphicon-eye-close"
                        title="Not Validated"
                      >
                        <fa :icon="['fas', 'eye-slash']" />
                      </span>
                    </label>
                    <label
                      :class="
                        prop.value == 'indeterminate'
                          ? 'btn dashed-border yellowBtn'
                          : 'btn dashed-border unSelectedIcons'
                      "
                    >
                      <input
                        type="radio"
                        :checked="prop.value == 'indeterminate'"
                        :name="prop.prop"
                        id="option2"
                        autocomplete="off"
                        value="indeterminate"
                        title="Indeterminate"
                        @change="changed($event, prop.prop)"
                      />
                      <span
                        class="glyphicon glyphicon-warning-sign"
                        title="Indeterminate"
                      >
                        <fa :icon="['fas', 'exclamation-triangle']" />
                      </span>
                    </label>
                    <label
                      :class="
                        prop.value == 'fail'
                          ? 'btn dashed-border redBtn'
                          : 'btn dashed-border unSelectedIcons'
                      "
                    >
                      <input
                        type="radio"
                        :checked="prop.value == 'fail'"
                        :name="prop.prop"
                        id="option3"
                        autocomplete="off"
                        value="fail"
                        title="Fail"
                        @change="changed($event, prop.prop)"
                      />
                      <span class="glyphicon glyphicon-thumbs-down" title="Fail">
                        <fa :icon="['fas', 'thumbs-down']" />
                      </span>
                    </label>
                    <label
                      :class="
                        prop.value == 'pass'
                          ? 'btn dashed-border greenBtn'
                          : 'btn dashed-border unSelectedIcons'
                      "
                    >
                      <input
                        type="radio"
                        :checked="prop.value == 'pass'"
                        :name="prop.prop"
                        id="option4"
                        autocomplete="off"
                        value="pass"
                        title="Pass"
                        @change="changed($event, prop.prop)"
                      />
                      <span class="glyphicon glyphicon-thumbs-up" title="Pass">
                        <fa :icon="['fas', 'thumbs-up']" />
                      </span>
                    </label>
                  </div>
                </b-col>
              </b-row>
            <b-row
              class="boxed section-bar py-1 px-4 mt-2"
              align-v="center"
              v-if="layerDefinition != 'HD' && ansiProperties.filter(e => e.type != 'required').length > 0"
            >
              <b-col>
                <label class="section-title my-1">OPTIONAL</label>
              </b-col>
              <b-col class="text-center">
                <b-button
                  size="sm"
                  class="ansi-button"
                  variant="btn-primary"
                  id="togglePass"
                  @click="toggleCategoryPass('')"
                >
                  Toggle Pass
                </b-button>
              </b-col>
            </b-row>
            <b-row
              align-h="between"
              class="prop-row py-1 px-5 mt-2"
              v-for="prop in ansiProperties.filter(e => e.type != 'required')"
              :key="prop.id"
            >
              <b-col cols="7" class="p-2">
                <span class="prop-name">
                  <strong>{{ prop.prop }}</strong>
                </span>
              </b-col>
              <b-col cols="5">
                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                  <label
                    :class="
                      prop.value == 'not_validated'
                        ? 'btn grayBtn'
                        : 'btn unSelectedIcons'
                    "
                  >
                    <input
                      type="radio"
                      :checked="prop.value == 'not_validated'"
                      :name="prop.prop"
                      id="option1"
                      autocomplete="off"
                      value="not_validated"
                      title="Not Validated"
                      @change="changed($event, prop.prop)"
                    />
                    <span
                      class="glyphicon glyphicon-eye-close"
                      title="Not Validated"
                    >
                      <fa :icon="['fas', 'eye-slash']" />
                    </span>
                  </label>
                  <label
                    :class="
                      prop.value == 'indeterminate'
                        ? 'btn yellowBtn'
                        : 'btn unSelectedIcons'
                    "
                  >
                    <input
                      type="radio"
                      :checked="prop.value == 'indeterminate'"
                      :name="prop.prop"
                      id="option2"
                      autocomplete="off"
                      value="indeterminate"
                      title="Indeterminate"
                      @change="changed($event, prop.prop)"
                    />
                    <span
                      class="glyphicon glyphicon-warning-sign"
                      title="Indeterminate"
                    >
                      <fa :icon="['fas', 'exclamation-triangle']" />
                    </span>
                  </label>
                  <label
                    :class="
                      prop.value == 'fail'
                        ? 'btn redBtn'
                        : 'btn unSelectedIcons'
                    "
                  >
                    <input
                      type="radio"
                      :checked="prop.value == 'fail'"
                      :name="prop.prop"
                      id="option3"
                      autocomplete="off"
                      value="fail"
                      title="Fail"
                      @change="changed($event, prop.prop)"
                    />
                    <span class="glyphicon glyphicon-thumbs-down" title="Fail">
                      <fa :icon="['fas', 'thumbs-down']" />
                    </span>
                  </label>
                  <label
                    :class="
                      prop.value == 'pass'
                        ? 'btn greenBtn'
                        : 'btn unSelectedIcons'
                    "
                  >
                    <input
                      type="radio"
                      :checked="prop.value == 'pass'"
                      :name="prop.prop"
                      id="option4"
                      autocomplete="off"
                      value="pass"
                      title="Pass"
                      @change="changed($event, prop.prop)"
                    />
                    <span class="glyphicon glyphicon-thumbs-up" title="Pass">
                      <fa :icon="['fas', 'thumbs-up']" />
                    </span>
                  </label>
                </div>
              </b-col>
            </b-row>
            </div>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import { check } from 'prettier'
import MMP_NotesTemplate from '../shared/MMP_NotesTemplate.vue'
export default {
  name: 'MMP_ANSI_Testing',
  props: ['apiUrl', 'layerDefinition', 'hdLayerSelected', 'user', 'selectedExtent'],
  components: {
    MMP_NotesTemplate
  },
  data() {
    return {
      ansiProperties: [],
      ansiWindow: true,
      ansi_notes: [],
      getApiUrl: '/api/' + this.apiUrl,
      notes: null,
      opts: [],
      part_number: null,
      properties: [],
      required_props: [],
      road_type: null,
      segmentId: null,
      showModal: false,
      state_name: null,
      technician: null,
      ushrId: null,
      osm_id: null,
      id_: null,
      validateOverallStatus: null,
      selset: null
    }
  },
  methods: {
    async closeWindow() {
      this.validateOverallStatus = await this.getStatus()
      if (this.validateOverallStatus != 'not_validated') {
        this.ansiWindow = false
        this.$emit('ansiTestingVisibility')
        this.saveEndTimeForAnsi()
        this.saveStartTimeForAnsi()
        this.$parent.$parent.$parent.$refs.AnsiFeatureTableRef?.trackAnsiSegmentReview({
          ansi_id: this.segmentId == undefined ? this.ushrId : this.segmentId,
          selset: this.selset
        })
        this.$emit('closeAnsiTestingWindow')
      } else {
        this.$bvToast.toast('Please confirm ANSI is validated.', {
          title: 'ANSI Submission Status',
          variant: 'danger',
          toaster: 'b-toaster-bottom-center'
        })
      }
    },
    async updateSite() {
      let opts = []
      this.ansiProperties.forEach(ob => {
        opts.push(ob.prop, ob.value)
      })

      // Flatten the array
      opts = opts.flat()
      // Create an empty object
      let obj = {}
      for (let i = 0; i < opts.length; i++) {
        if (i % 2 == 0) {
          // Extract the key and the value
          let key = opts[i]
          let value = opts[i + 1]
          // Assign the key and value
          obj[key] = value
        }
      }

      let status = await this.getStatus()
      let opts_param = {
        id: this.ushrId,
        tech: this.user.name,
        notes: this.notes,
        passed: status,
        Overall: status
      }

      this.validateOverallStatus = opts_param.Overall
      if (this.validateOverallStatus != 'not_validated') {
        var mergedObj = Object.assign(obj, opts_param)
        if (this.layerDefinition == 'HD') {
          let hd_param = {
            id_: this.id_,
            table_name: this.hdLayerSelected
          }
          var mergedObj = Object.assign(obj, hd_param)
        }
        let customUrl = this.layerDefinition == 'HD' ? '/updateFullChecks' : '/'

        const hasNull = Object.values(mergedObj).some(v => v === null)

        if (!hasNull) {
          axios
            .get(process.env.API_LOCATION + this.getApiUrl + customUrl, {
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {mergedObj}
            })
            .then(response => {
              const content = response.data
              this.$emit('refresh', 'ANSI')
              this.$bvToast.toast('Entry saved successfully.', {
                title: 'ANSI Submission Status',
                variant: 'success',
                toaster: 'b-toaster-bottom-center'
              })
            })
            .catch(function (error) {
              console.log(error)
            })
          this.closeWindow()
        } else {
          this.$bvToast.toast('Please confirm ANSI is validated.', {
            title: 'ANSI Submission Status',
            variant: 'danger',
            toaster: 'b-toaster-bottom-center'
          })
        }
      } else {
        this.$bvToast.toast('Please confirm ANSI is validated.', {
          title: 'ANSI Submission Status',
          variant: 'danger',
          toaster: 'b-toaster-bottom-center'
        })
      }
    },
    getStatus() {
      var values = []
      this.ansiProperties.forEach(radios => {
        values.push({name: radios.value, type: radios.type})
      })
      if (
        values.filter(e => e.name === 'not_validated' && e.type === 'required')
          .length > 0
      ) {
        return 'not_validated'
      } else if (values.filter(e => e.name === 'fail').length > 0) {
        return 'fail'
      } else {
        return 'pass'
      }
    },
    async togglePass() { 
      this.ansiProperties.forEach(val => {
        val.value = 'pass'
      })

      await this.$nextTick()
    },
    toggleCategoryPass(category) { 
      this.ansiProperties.forEach(val => {
        if (val.type == category) {
          val.value = 'pass'
        }
      })
    },
    /* loadAnsiData function gets the data generated by the single-click event
       from parent and renders the data in the ANSI Testing Window */
    async loadAnsiData(data) {
      if (data != undefined && data != null && data.properties) { 
        this.ansiWindow = true
        var feature = data.properties 
        this.segmentId =
          this.layerDefinition == 'HD'
            ? feature.segment_id
            : feature.id_ != null
              ? feature.id_
              : feature.road_segment_id == null
                ? feature.id 
                : feature.road_segment_id
        this.ushrId = isNaN(data.id.split('.')[1]) ? this.segmentId : data.id.split('.')[1]
        this.state_name =
          feature.state_name != null ? feature.state_name : feature.region 
        this.road_type = feature.type != null ? feature.type : feature.road_type 
        this.technician = feature.technician 
        this.notes = feature.notes 
        this.part_number = feature.part_number
        this.selset = feature.selset
        this.osm_id = feature.osm_id == undefined ? null : feature.osm_id
        this.id_ = feature.id_ == undefined ? null : feature.id_
        this.ansiProperties = []
        this.properties = []
        let customURL =
          this.layerDefinition == 'HD'
            ? '/getHDProperties'
            : '/getANSIProperties'
        axios
          .get(process.env.API_LOCATION + this.getApiUrl + customURL, {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              layerSelected: this.hdLayerSelected,
              selectedExtent: this.selectedExtent,
            }
          })
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.properties = content.rows
              this.getRequiredProps()
              let index = this.properties.length
              Object.entries(feature).forEach(element => { 
                const [key, value] = element
                let val = this.properties.find(elem => elem.name === key)
                if (val != undefined) {
                  if (this.layerDefinition != 'HD') {
                    this.ansiProperties.push({
                      prop: key,
                      value: (value == null || value == '') ? 'not_validated' : value,
                      type: 'required',
                      //type: props.length > 0 ? 'required' : '',
                      id: index
                    })
                  } else {
                    let props = this.required_props.filter(e => e.name === key)
                    this.ansiProperties.push({
                      prop: key,
                      value: (value == null || value == '') ? 'not_validated' : value,
                      type: 'required',
                      type: props.length > 0 ? 'required' : '',
                      id: index
                    })
                  }
                }
                index = index - 1
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        let ansiSegments = await this.$parent.$parent.$parent.$refs.AnsiFeatureTableRef.getTableBySelset()
        let segment = ansiSegments.filter((seg) => seg.ansi_id == this.segmentId)
        if (segment[0]) {
          let row = {
            selected_item: segment[0]
          }
          this.$parent.$parent.$parent.$refs.ansiNav.setAnsiSegmentsHistory(ansiSegments, row)
        }
        this.$parent.$parent.$parent.$refs.AnsiFeatureTableRef?.endAnsiSegmentReview()
        this.saveStartTimeForAnsi()
        this.$parent.$parent.$parent.$refs.AnsiFeatureTableRef?.trackAnsiSegmentReview({
          ansi_id: this.segmentId == undefined ? this.ushrId : this.segmentId,
          selset: this.selset
        })
      }
    },
    changed(e, prop) {
      var checkedLabel = e.target

      this.ansiProperties.forEach(item => {
        if (prop === item.prop) {
          item.value = checkedLabel.value
          return
        }
      })
    },
    enableInput(e) {
      /* Vue-Moveable js disabled the left-click event in order to increase convenience
      for dragging the window and enabled right-click to set the focus on textarea and
      input box, hence this function resets that. */
      e.target.contentEditable = 'true'
      this.$refs.notes.focus()
    },
    getRequiredProps() {
      if (sessionStorage.token) {
        let customURL =
          this.layerDefinition == 'ANSI'
            ? '/getRequiredProps'
            : '/getHDRequiredProps'
        axios
          .get(process.env.API_LOCATION + this.getApiUrl + customURL, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.required_props = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({name: 'Login'})
      }
    },
    getAnsiNotes() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/ansi_notes/getAnsiNotes', {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              this.$router.push({name: 'Login'})
            } else {
              this.ansi_notes = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.feedback = 'No Apps For you'
        this.$router.push({name: 'Login'})
      }
    },
    pushToNotes(value) {
      this.notes = value
      this.showModal = false
    },
    showNotesModal() {
      this.showModal = !this.showModal
    },
    saveEndTimeForAnsi() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + this.getApiUrl + '/saveEndTimeForAnsi/',
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                partNumber: this.part_number,
                segmentId:
                  this.segmentId == undefined ? this.ushrId : this.segmentId
              }
            }
          )
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({name: 'Login'})
      }
    },
    saveStartTimeForAnsi() {
      // This ternary operator handles Subaru ANSI random segments which does not have segment id but has ushr ANSI Id instead.
      if (sessionStorage.token) {
        // REFACTORED -- WEBGIS-2550 -- Adding check to see if data is empty since there's issues with saving review time
        if (this.part_number && this.segmentId && this.selset) {
          axios
          .get(
            process.env.API_LOCATION +
              '/api/' +
              this.apiUrl +
              '/saveStartTimeForAnsi/',
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                partNumber: this.part_number,
                segmentId: this.segmentId,
                selset: this.selset
              }
            }
          )
          .catch(function (error) {
            console.log(error)
          })
        } else {
          console.log('Error saving start time for Ansi Segment - no data available')
        }
      } else {
        this.$router.push({name: 'Login'})
      }
    }
  },
  mounted() {
     this.getRequiredProps()
    this.getAnsiNotes()

    setTimeout(() => {
      if (this.ansiProperties.filter(e => e.type === 'required').length == 0 || this.ansiProperties.length == 0) {
        this.ansiWindow = false
      }
    }, 3000)
  },
  updated() {
    this.$emit('ansiTestingDataUpdated')
  }
}
</script>

<style scoped>
/* ── Card shell ─────────────────────────────────────────── */
.panel {
  max-height: 90vh;
  background: #ffffff;
  color: #063c6d;
  border: 1px solid rgba(6, 60, 109, 0.12);
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(4, 30, 58, 0.28);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.panel ::v-deep(.card-body) {
  padding: 14px 16px 16px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.scroll-Container {
  flex: 1 1 auto;
  min-height: 0;
  max-height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;
}
/* Slim, themed scrollbar */
/* .scroll-Container::-webkit-scrollbar {
  width: 8px;
}
.scroll-Container::-webkit-scrollbar-thumb {
  background: rgba(6, 60, 109, 0.25);
  border-radius: 8px;
}
.scroll-Container::-webkit-scrollbar-thumb:hover {
  background: rgba(6, 60, 109, 0.4);
} */

/* ── Header ─────────────────────────────────────────────── */
.ansi-testing-header {
  color: white !important;
  padding: 10px 14px;
  border-bottom: none !important;
}
.ansi-testing-header .btn {
  color: white !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.82rem;
  letter-spacing: 0.02em;
  padding: 6px 10px;
  transition: filter 0.15s ease, transform 0.12s ease, box-shadow 0.15s ease;
}
.ansi-testing-header .btn:hover {
  filter: brightness(1.08);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.ansi-testing-header .btn:active {
  transform: translateY(0);
}
.ansi-testing-header .close-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgb(18, 67, 172);
  color: #ffffff;
  font-size: 0.9rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease,
    box-shadow 0.15s ease;
}
.ansi-testing-header .close-icon-btn:hover {
  background: #e5484d;
  color: #ffffff;
  transform: scale(1.1);
  box-shadow: 0 3px 10px rgba(229, 72, 77, 0.45);
}
.ansi-testing-header .close-icon-btn:active {
  transform: scale(0.95);
}
.ansi-testing-header .close-icon-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
}

/* ── Read-only info grid ────────────────────────────────── */
.info-grid {
  background: rgba(6, 60, 109, 0.045);
  border: 1px solid rgba(6, 60, 109, 0.08);
  border-radius: 10px;
  padding: 4px 6px;
  margin-left: 2px;
  margin-right: 2px;
}
.info-grid label {
  display: block;
  margin: 0;
  font-size: 0.85rem;
  color: #063c6d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info-grid b {
  display: block;
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(6, 60, 109, 0.55);
  margin-bottom: 1px;
}

/* ── Notes ──────────────────────────────────────────────── */
.notesRow {
  padding-left: 15px;
  align-items: center;
  color: #063c6d;
  margin-top: 10px;
  margin-bottom: 10px;
}
.notes {
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.02em;
  margin: 8px 0 4px;
}
.testingWindowNotes {
  margin-left: 6px;
  cursor: pointer;
}
.contenteditable-element {
  user-select: text;
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  border-radius: 8px !important;
  color: #063c6d !important;
  resize: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}
.contenteditable-element:focus {
  background: #fff !important;
  border-color: #0a5499 !important;
  box-shadow: 0 0 0 3px rgba(10, 84, 153, 0.15) !important;
  outline: none;
}

/* ── Section headers (ATTRIBUTES / REQUIRED / OPTIONAL) ──── */
.boxed {
  background: rgba(6, 60, 109, 0.06);
  border: none !important;
  border-radius: 8px;
  color: #063c6d;
}
.section-bar {
  border-left: 3px solid #0a5499 !important;
  margin-top: 15px !important;
}
.section-title {
  display: inline-block;
  margin: 4px 0;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #063c6d;
}

/* ── Property rows ──────────────────────────────────────── */
.prop-row {
  border-radius: 8px;
  transition: background 0.12s ease;
}
.prop-row:hover {
  background: rgba(10, 84, 153, 0.05);
}
.prop-name {
  font-size: 0.9rem;
  color: #063c6d;
}

/* ── Toggle button group (segmented control) ────────────── */
.btn-group-toggle {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(6, 60, 109, 0.12);
}
.btn-group-toggle .btn {
  color: #063c6d;
  border: 1px solid rgba(6, 60, 109, 0.15);
  padding: 5px 12px;
  transition: background 0.15s ease, color 0.15s ease, transform 0.1s ease;
}
.btn-group-toggle .btn:hover {
  transform: translateY(-1px);
}
.unSelectedIcons {
  background: #f3f5f8 !important;
  color: rgba(6, 60, 109, 0.65) !important;
}
.unSelectedIcons:hover {
  background: #e6edf5 !important;
  color: #063c6d !important;
}
.dashed-border {
  border: 1px dashed rgba(6, 60, 109, 0.35);
}

/* ── Notes template side panel ──────────────────────────── */
.notes_panel {
  background: linear-gradient(180deg, #f7f9fc 0%, #eef2f8 100%);
  /* border: 1px solid rgba(6, 60, 109, 0.12); */
  border-radius: 12px;
  padding: 6px 8px 10px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6),
    0 4px 14px rgba(4, 30, 58, 0.08);
}
.notes-panel-title {
  position: sticky;
  /* top: 0; */
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: -6px -8px 8px;
  padding: 8px 10px;
  font-size: 0.82rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #ffffff;
  background: linear-gradient(135deg, #0a5499, #063c6d);
  border-radius: 12px 12px 0 0;
  box-shadow: 0 2px 8px rgba(6, 60, 109, 0.25);
}
.notes-panel-title .svg-inline--fa {
  opacity: 0.85;
}
/* Hide the scrollbar strip on the right of the notes list (still scrollable) */
.notes_panel .scroll-Container {
  scrollbar-width: none;
}
.notes_panel .scroll-Container::-webkit-scrollbar {
  display: none;
}
.notes_panel .ansi-button {
  width: 100%;
  border-radius: 8px;
  white-space: normal;
  font-size: 0.8rem;
  line-height: 1.3;
  padding: 8px 10px;
  color: #063c6d !important;
  background: #ffffff !important;
  border: 1px solid rgba(6, 60, 109, 0.14) !important;
  box-shadow: 0 1px 2px rgba(6, 60, 109, 0.06);
  transition: background 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, transform 0.12s ease;
}
.notes_panel .ansi-button:hover {
  background: #f0f6ff !important;
  border-color: #0a5499 !important;
  box-shadow: 0 4px 12px rgba(10, 84, 153, 0.18);
  transform: translateY(-1px);
}
.notes_panel .ansi-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(10, 84, 153, 0.2);
}
.cog-position {
  margin-left: 5px;
  cursor: pointer;
  color: rgba(6, 60, 109, 0.65);
}

/* ── Window sizing ──────────────────────────────────────── */
.window-widthfixed {
  width: min(40.625rem, 90vw) !important;
}
.window-width {
  width: min(57.5rem, 90vw) !important;
}
.remove-window-spacing {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
}
.btn {
  color: #063c6d;
}
</style>
